import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Reveal, Eyebrow } from "@/components/Reveal";

const CATEGORIES = ["All", "Tees", "Hoodies", "Sets"];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState(null);
  const category = params.get("category") || "All";
  const isDrop = params.get("drop") === "new";

  useEffect(() => {
    setProducts(null);
    const query = {};
    if (isDrop) query.drop = true;
    else if (category !== "All") query.category = category;
    api.get("/products", { params: query }).then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, [category, isDrop]);

  const selectCategory = (c) => {
    setParams(c === "All" ? {} : { category: c });
  };

  return (
    <div className="pt-16" data-testid="shop-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-10">
        <Reveal><Eyebrow>{isDrop ? "Drop 001 — Founders" : "The Full Range"}</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-display font-extrabold uppercase tracking-tight text-5xl sm:text-7xl mt-4 leading-[0.9]">
            {isDrop ? <>New <span className="text-outline">Drop</span></> : category === "All" ? <>Shop <span className="text-outline">All</span></> : <>{category.slice(0, -0)} <span className="text-outline">{category === "Tees" || category === "Polos" ? "" : ""}</span></>}
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-cream/50 text-sm max-w-lg">
            {isDrop
              ? "The founding release. Numbered pieces, heavyweight fabrics, no second pressings."
              : "Heavyweight tees, fleece, outerwear and accessories — built in silence, made to last."}
          </p>
        </Reveal>
      </div>

      <div className="sticky top-16 z-40 bg-noir-bg/90 backdrop-blur-md border-y border-white/10" data-testid="shop-filter-bar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex gap-1 overflow-x-auto py-3">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => selectCategory(c)}
              className={`font-mono2 text-[10px] tracking-[0.25em] uppercase px-4 py-2 whitespace-nowrap transition-colors duration-300 ${!isDrop && category === c ? "bg-gold text-noir-bg" : "text-cream/60 hover:text-gold"}`}
              data-testid={`filter-${c.toLowerCase()}`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        {products === null ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[3/4] bg-noir-card animate-pulse" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <p className="text-cream/40 font-mono2 text-xs tracking-[0.3em] uppercase py-20 text-center" data-testid="shop-empty">Nothing here yet — the next drop is being built in silence.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="shop-grid">
            {products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
